export default __webpack_public_path__ + "static/media/cpv_14_mining-metal.c4960306.svg";